__turbopack_context__.v({
  "className": "newsreader_9efb9fed-module__XXlduW__className",
});
